<template>
  <div>
    <common-table :table-columns="tableColumns" :form-fields="{model: []}" :url="url" :permission="{}" :operate="[]"
                  :searchs="searchs"/>
  </div>
</template>

<script>
import CommonTable from "../../components/CommonTable/CommonTable";

export default {
  name: "CapitalRecord",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'phone',
        placeholder: '手机号',
        type: 'input'
      }, {
        name: 'startTime',
        placeholder: '开始时间',
        type: 'dateTime'
      }, {
        name: 'endTime',
        placeholder: '结束时间',
        type: 'dateTime'
      }],
      url: {
        get: '/capitalRecord/listByCondition',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        //width: '75',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'phone',
        label: '用户',
        show: true,
        width: '',
      }, {
        field: 'earnings',
        label: '变动积分',
        show: true,
        width: '',
      }, {
        field: 'accountBalance',
        label: '总金额',
        show: false,
        width: '',
      }, {
        field: 'walletBalance',
        label: '活期账户',
        show: false,
        width: '',
      }, {
        field: 'promotionBalance',
        label: '智能账户',
        show: false,
        width: '',
      }, {
        field: 'promotionAccountBalance',
        label: '积分',
        show: true,
        width: '',
      }, {
        field: 'rechargeMoney',
        label: '累计充值',
        show: false,
        width: '',
      }, {
        field: 'type',
        label: '项目说明',
        show: {
          type: 'select',
        },
        selectData: [{
          id: 1,
          name: '挖矿收益'
        }, {
          id: 2,
          name: '发起钱包提现'
        }, {
          id: 3,
          name: '发起推广提现'
        }, {
          id: 4,
          name: '钱包提现失败返回'
        }, {
          id: 5,
          name: '推广提现失败返回'
        }, {
          id: 6,
          name: '团队充值返利'
        }, {
          id: 7,
          name: '钱包充值'
        }, {
          id: 8,
          name: '推广余额转入钱包余额'
        }, {
          id: 9,
          name: '加积分'
        }, {
          id: 10,
          name: '减积分'
        }, {
          id: 11,
          name: '注册奖励'
        }, {
          id: 12,
          name: '推广注册奖励'
        }, {
          id: 13,
          name: '微信充值'
        }, {
          id: 14,
          name: '预剪辑'
        }, {
          id: 15,
          name: '投资收益'
        }, {
          id: 16,
          name: '钱包充值回滚'
        }, {
          id: 17,
          name: '促销充值回滚'
        }, {
          id: 18,
          name: '团队充值返利回滚'
        }, {
          id: 19,
          name: '购买天天投资'
        }, {
          id: 20,
          name: '天天投资收益'
        }, {
          id: 20,
          name: '充值赠送基础钱包金额'
        }, {
          id: 21,
          name: '基础钱包充值赠送基础钱包金额'
        }, {
          id: 22,
          name: '基础钱包充值赠送推广钱包金额'
        }, {
          id: 23,
          name: '促销钱包充值赠送基础钱包金额'
        }, {
          id: 24,
          name: '促销钱包充值赠送推广钱包金额'
        }, {
          id: 25,
          name: '活动抽奖'
        }, {
          id: 26,
          name: '智能投资到期'
        }, {
          id: 27,
          name: '首充返利'
        }, {
          id: 28,
          name: '下级首充返利'
        }, {
          id: 29,
          name: '累计充值'
        }, {
          id: 30,
          name: '兑换积分'
        }, {
          id: 31,
          name: '提现手续费'
        }],
        width: '',
      }, {
        field: 'expound',
        label: '说明',
        show: true,
        width: '',
      }, {
        field: 'createTime',
        label: '创建时间',
        show: true,
        width: '',
      }],
    }
  }
}
</script>

<style scoped>

</style>
